import { Typography } from "antd";
import TodoEState from "./EmptyStatesIcons/TodoEState";
import ProjectEState from "./EmptyStatesIcons/ProjectEState";
import ProductivityEState from "./EmptyStatesIcons/ProductivityEState";
import EfficiencyEState from "./EmptyStatesIcons/EfficiencyEState";
import AppTrackingEState from "./EmptyStatesIcons/AppTrackingEState";
import ScreenShotsEState from "./EmptyStatesIcons/ScreenShotsEState";
import ChromeExtensionEState from "./EmptyStatesIcons/ChromeExtensionEState";
import ProductivityChampEState from "./EmptyStatesIcons/ProductivityChampEState";
import TimeHeroEState from "./EmptyStatesIcons/TimeHeroEState";
import ConnectionEstate from "./EmptyStatesIcons/ConnectionEstate";
import UserEState from "./EmptyStatesIcons/UserEState";
import HiddenEState from "./EmptyStatesIcons/HiddenEState";
import ResourcesEState from "./EmptyStatesIcons/ResourcesEState";
import DocumentsEState from "./EmptyStatesIcons/DocumentsEState";
import AwardEState from "./EmptyStatesIcons/AwardEState";
import AnnouncementEState from "./EmptyStatesIcons/AnnouncementEState";
import DataEState from "./EmptyStatesIcons/DataEState";
import NotificationEState from "./EmptyStatesIcons/NotificationEState";
import EmployeeEState from "./EmptyStatesIcons/EmployeeEState";
import LeaveEState from "./EmptyStatesIcons/LeaveEState";
import UpcomingLeaveEState from "./EmptyStatesIcons/UpcomingLeaveEState";
import PayrollEState from "./EmptyStatesIcons/PayrollEState";
import SwitchEState from "./EmptyStatesIcons/SwitchEState";
import GenderEState from "./EmptyStatesIcons/GenderEState";
import BirthdayEState from "./EmptyStatesIcons/BirthdayEState";
import WorkAnniversaryEState from "./EmptyStatesIcons/WorkAnniversaryEState";
import TimeSheetEState from "./EmptyStatesIcons/TimeSheetEState";
import CompanyAnnouncementEState from "./EmptyStatesIcons/CompanyAnnouncementEState";
import NoInputEState from "./EmptyStatesIcons/NoInputEState";
import CalanderEState from "./EmptyStatesIcons/CalanderEState";
import OnLeaveEState from "./EmptyStatesIcons/OnLeaveEState";
import DarkAnnouncement from "./NewEmptyEmptyState/Dark/DarkAnnouncement";
import DarkBirthday from "./NewEmptyEmptyState/Dark/DarkBirthday";
import DarkLeaveRequest from "./NewEmptyEmptyState/Dark/DarkLeaveRequest";
import DarkPayroll from "./NewEmptyEmptyState/Dark/DarkPayroll";
import DarkTeam from "./NewEmptyEmptyState/Dark/DarkTeam";
import DarkWhatsHappening from "./NewEmptyEmptyState/Dark/DarkWhatsHappening";
import DarkWorkAnniv from "./NewEmptyEmptyState/Dark/DarkWorkAnniv";

import LightAnnouncement from "./NewEmptyEmptyState/Light/LightAnnouncement";
import LightBirthday from "./NewEmptyEmptyState/Light/LightBirthday";
import LightLeaveRequest from "./NewEmptyEmptyState/Light/LightLeaveRequest";
import LightPayroll from "./NewEmptyEmptyState/Light/LightPayroll";
import LightTeam from "./NewEmptyEmptyState/Light/LightTeam";
import LightUpcomingLeaves from "./NewEmptyEmptyState/Light/LightUpcomingLeaves";
import LightWhatsHappening from "./NewEmptyEmptyState/Light/LightWhatsHappening";
import LightWorkAnniv from "./NewEmptyEmptyState/Light/LightWorkAnniv";
import DarkUpcomingLeaves from "./NewEmptyEmptyState/Dark/DarkUpcomingLeaves";

const { Text } = Typography;

export const NewEmptyStatesData = (themeDefault) => {
  let theme =
    themeDefault?.info?.themeColor === "purple"
      ? true
      : themeDefault?.info?.themeColor === "dark"
      ? true
      : themeDefault?.info?.themeColor === "default"
      ? false
      : false;

  return [
    {
      id: "announcement",
      label: "Announcement",
      text: "Text Goes here",
      code: theme ? "<DarkAnnouncement />" : "<LightAnnouncement />",
      emptyState: theme ? DarkAnnouncement : LightAnnouncement,
    },
    {
      id: "birthday",
      label: "Birthday",
      text: "Text Goes here",
      code: theme ? "<DarkBirthday />" : "<LightBirthday />",
      emptyState: theme ? DarkBirthday : LightBirthday,
    },
    {
      id: "leave-request",
      label: "Leave Request",
      text: "Text Goes here",
      code: theme ? "<DarkLeaveRequest />" : "<LightLeaveRequest />",
      emptyState: theme ? DarkLeaveRequest : LightLeaveRequest,
    },
    {
      id: "payroll",
      label: "Payroll",
      text: "Text Goes here",
      code: theme ? "<DarkPayroll />" : "<LightPayroll />",
      emptyState: theme ? DarkPayroll : LightPayroll,
    },
    {
      id: "team",
      label: "Team",
      text: "Text Goes here",
      code: theme ? "<DarkTeam />" : "<LightTeam />",
      emptyState: theme ? DarkTeam : LightTeam,
    },
    {
      id: "upcoming-leaves",
      label: "Upcoming Leaves",
      text: "Text Goes here",
      code: theme ? "<DarkUpcomingLeaves />" : "<LightUpcomingLeaves />",
      emptyState: theme ? DarkUpcomingLeaves : LightUpcomingLeaves,
    },
    {
      id: "whats-happening",
      label: "What's Happening",
      text: "Text Goes here",
      code: theme ? "<DarkWhatsHappening />" : "<LightWhatsHappening />",
      emptyState: theme ? DarkWhatsHappening : LightWhatsHappening,
    },
    {
      id: "work-anniversary",
      label: "Work Anniversary",
      text: "Text Goes here",
      code: theme ? "<DarkWorkAnniv />" : "<LightWorkAnniv />",
      emptyState: theme ? DarkWorkAnniv : LightWorkAnniv,
    },
  ];
};

export const NewEmptyStatesDarkData = [
  {
    id: "announcement",
    label: "Announcement",
    text: "Text Goes here",
    code: "<DarkAnnouncement />",
    emptyState: DarkAnnouncement,
  },
  {
    id: "birthday",
    label: "Birthday",
    text: "Text Goes here",
    code: "<DarkBirthday />",
    emptyState: DarkBirthday,
  },
  {
    id: "leave-request",
    label: "Leave Request",
    text: "Text Goes here",
    code: "<DarkLeaveRequest />",
    emptyState: DarkLeaveRequest,
  },
  {
    id: "payroll",
    label: "Payroll",
    text: "Text Goes here",
    code: "<DarkPayroll />",
    emptyState: DarkPayroll,
  },
  {
    id: "team",
    label: "Team",
    text: "Text Goes here",
    code: "<DarkTeam />",
    emptyState: DarkTeam,
  },
  {
    id: "upcoming-leaves",
    label: "Upcoming Leaves",
    text: "Text Goes here",
    code: "<DarkUpcomingLeaves />",
    emptyState: DarkUpcomingLeaves,
  },
  {
    id: "whats-happening",
    label: "What's Happening",
    text: "Text Goes here",
    code: "<DarkWhatsHappening />",
    emptyState: DarkWhatsHappening,
  },
  {
    id: "work-anniversary",
    label: "Work Anniversary",
    text: "Text Goes here",
    code: "<DarkWorkAnniv />",
    emptyState: DarkWorkAnniv,
  },
];

export const NewEmptyStatesLightData = [
  {
    id: "announcement",
    label: "Announcement",
    text: "Text Goes here",
    code: "<LightAnnouncement />",
    emptyState: LightAnnouncement,
  },
  {
    id: "birthday",
    label: "Birthday",
    text: "Text Goes here",
    code: "<LightBirthday />",
    emptyState: LightBirthday,
  },
  {
    id: "leave-request",
    label: "Leave Request",
    text: "Text Goes here",
    code: "<LightLeaveRequest />",
    emptyState: LightLeaveRequest,
  },
  {
    id: "payroll",
    label: "Payroll",
    text: "Text Goes here",
    code: "<LightPayroll />",
    emptyState: LightPayroll,
  },
  {
    id: "team",
    label: "Team",
    text: "Text Goes here",
    code: "<LightTeam />",
    emptyState: LightTeam,
  },
  {
    id: "upcoming-leaves",
    label: "Upcoming Leaves",
    text: "Text Goes here",
    code: "<LightUpcomingLeaves />",
    emptyState: LightUpcomingLeaves,
  },
  {
    id: "whats-happening",
    label: "What's Happening",
    text: "Text Goes here",
    code: "<LightWhatsHappening />",
    emptyState: LightWhatsHappening,
  },
  {
    id: "work-anniversary",
    label: "Work Anniversary",
    text: "Text Goes here",
    code: "<LightWorkAnniv />",
    emptyState: LightWorkAnniv,
  },
];

export const emptyStatesData = [
  {
    id: "todo",
    label: "To do",
    text: "Text Goes here",
    code: "<TodoEState />",
    emptyState: TodoEState,
  },
  {
    id: "project",
    label: "Project",
    text: "Text Goes here",
    code: "<ProjectEState />",
    emptyState: ProjectEState,
  },
  {
    id: "productivity",
    label: "Productivity",
    text: "Text Goes here",
    code: "<ProductivityEState />",
    emptyState: ProductivityEState,
  },
  {
    id: "efficiency",
    label: "Efficiency",
    text: "Text Goes here",
    code: "<EfficiencyEState />",
    emptyState: EfficiencyEState,
  },
  {
    id: "appTracking",
    label: "App Tracking",
    text: "Text Goes here",
    code: "<AppTrackingEState />",
    emptyState: AppTrackingEState,
  },
  {
    id: "screenShots",
    label: "ScreenShots",
    text: "Text Goes here",
    code: "<ScreenShotsEState />",
    emptyState: ScreenShotsEState,
  },
  {
    id: "chromeExtension",
    label: "Chrome Extension",
    text: "Text Goes here",
    code: "<ChromeExtensionEState />",
    emptyState: ChromeExtensionEState,
  },
  {
    id: "productivityChamp",
    label: "Productivity Champ",
    text: "Text Goes here",
    code: "<ProductivityChampEState />",
    emptyState: ProductivityChampEState,
  },
  {
    id: "timeHero",
    label: "Time Hero",
    text: "Text Goes here",
    code: "<TimeHeroEState />",
    emptyState: TimeHeroEState,
  },
  {
    id: "connection",
    label: "Connection",
    text: "Text Goes here",
    code: "<ConnectionEstate />",
    emptyState: ConnectionEstate,
  },
  {
    id: "user",
    label: "User",
    text: "Text Goes here",
    code: "<UserEstate />",
    emptyState: UserEState,
  },
  {
    id: "hidden",
    label: "Hidden",
    text: "Text Goes here",
    code: "<HiddenEstate />",
    emptyState: HiddenEState,
  },
  {
    id: "resources",
    label: "Resources",
    text: "Text Goes here",
    code: "<ResourcesEstate />",
    emptyState: ResourcesEState,
  },
  {
    id: "documents",
    label: "Documents",
    text: "Text Goes here",
    code: "<DocumentsEstate />",
    emptyState: DocumentsEState,
  },
  {
    id: "award",
    label: "Award",
    text: "Text Goes here",
    code: "<AwardEstate />",
    emptyState: AwardEState,
  },
  {
    id: "announcement",
    label: "Announcement",
    text: "Text Goes here",
    code: "<AnnouncementEstate />",
    emptyState: AnnouncementEState,
  },
  {
    id: "data",
    label: "Data",
    text: "Text Goes here",
    code: "<DataEstate />",
    emptyState: DataEState,
  },
  {
    id: "notification",
    label: "Notification",
    text: "Text Goes here",
    code: "<NotificationEstate />",
    emptyState: NotificationEState,
  },
  {
    id: "employee",
    label: "Employee",
    text: "Text Goes here",
    code: "<EmployeeEstate />",
    emptyState: EmployeeEState,
  },
  {
    id: "leave",
    label: "Leave",
    text: "Text Goes here",
    code: "<LeaveEstate />",
    emptyState: LeaveEState,
  },
  {
    id: "payroll",
    label: "Payroll",
    text: "Text Goes here",
    code: "<PayrollEstate />",
    emptyState: PayrollEState,
  },
  {
    id: "upcomingLeave",
    label: "Upcoming Leave",
    text: "Text Goes here",
    code: "<UpcomingLeaveEstate />",
    emptyState: UpcomingLeaveEState,
  },
  {
    id: "switch",
    label: "Switch",
    text: "Text Goes here",
    code: "<SwitchEstate />",
    emptyState: SwitchEState,
  },
  {
    id: "gender",
    label: "Gender",
    text: "Text Goes here",
    code: "<GenderEstate />",
    emptyState: GenderEState,
  },
  {
    id: "birthday",
    label: "Birthday",
    text: "Text Goes here",
    code: "<BirthdayEstate />",
    emptyState: BirthdayEState,
  },
  {
    id: "workAnniversary",
    label: "Work Anniversary",
    text: "Text Goes here",
    code: "<WorkAnniversaryEstate />",
    emptyState: WorkAnniversaryEState,
  },
  {
    id: "timeSheet",
    label: "TimeSheet",
    text: "Text Goes here",
    code: "<TimeSheetEstate />",
    emptyState: TimeSheetEState,
  },
  {
    id: "noInput",
    label: "No Input",
    text: "Text Goes here",
    code: "<NoInputEstate />",
    emptyState: NoInputEState,
  },
  {
    id: "companyAnnouncement",
    label: "Company Announcement",
    text: "Text Goes here",
    code: "<CompanyAnnouncementEstate />",
    emptyState: CompanyAnnouncementEState,
  },
  {
    id: "calander",
    label: "Calander",
    text: "Text Goes here",
    code: "<CalanderEstate />",
    emptyState: CalanderEState,
  },
  {
    id: "onLeave",
    label: "On Leave",
    text: "Text Goes here",
    code: "<OnLeaveEstate />",
    emptyState: OnLeaveEState,
  },
];
